import React, { useState, useEffect } from 'react';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';

const NumberInput = ({ name, defaultValue, onSave }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    setValue(parseInt(e.target.value));
  };

  const handleSave = () => {
    if (value) {
      onSave({ [name]: value });
    }
  };

  return (
    <TextField
      className="input-field"
      placeholder="110"
      variant="outlined"
      value={value}
      type="number"
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleSave}>
              <SaveIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default NumberInput;
